<template lang="pug">
div(class="tl-input-error-text input-error")
    transition(
        mode="out-in"
        name="input-error-text-transition"
    )
        span(
            v-if="error && typeof error == 'string'"
            :class="{ 'animation-shake': error }"
            class="error-text"
        ) {{ error }}
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    error: [Array, String],
})

const injects = getInjects(props, inject)

const error = computed(() => props.error ?? injects.error?.value)
</script>

<style lang="sass" scoped>

.input-error
    height: auto
    display: flex
    align-items: center
    overflow: hidden

    .error-text
        padding: 5px
        font-size: 14px
        margin-top: 5px
        color: var(--tl-color-destructive) !important
        font-family: var(--font-family-secondary)
        font-size: 14px

.input-error-text-transition-enter-active
    transition: all .2s ease-in-out

.input-error-text-transition-enter-from
    opacity: 0
    transform: translateX(-10px)

.input-error-text-transition-enter-to
    opacity: 1
    transform: translateX(0px)

.input-error-text-transition-leave-active
    transition: all .2s ease-in-out

.input-error-text-transition-leave-from
    opacity: 1
    transform: translateX(0px)

.input-error-text-transition-leave-to
    opacity: 0
    transform: translateX(-10px)
</style>
